<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Notifica Notipay" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Utente:</label>
                    <span class="sa-data">{{ jsonData.proprietario }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Ora:</label>
                    <span class="sa-data">{{ formatDateTime(jsonData.createDate) }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Body Request:</label>
                    <!-- <span>{{ prettyFormat(jsonData.bodyResponse) }} </span> -->
                    <div class="text-danger">{{ jsonerrorRequest }}</div>
                    <!-- <b-form-textarea id="jsonText" v-model="jsonData.bodyResponse" placeholder="Parametro" rows="7"></b-form-textarea> -->
                    <pre>{{ prettyFormat(jsonData.bodyRequest) }}</pre>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Body Response:</label>
                    <!-- <span>{{ prettyFormat(jsonData.bodyResponse) }} </span> -->
                    <div class="text-danger">{{ jsonerrorResponse }}</div>
                    <!-- <b-form-textarea id="jsonText" v-model="jsonData.bodyResponse" placeholder="Parametro" rows="7"></b-form-textarea> -->
                    <pre>{{ prettyFormat(jsonData.bodyResponse) }}</pre>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import NotificationNotipayMixin from "../mixin/NotificationNotipayMixin";
export default {
    mixins: [NotificationNotipayMixin, UtilityMixin],
    data() {
        return {
            pathResource: "/notificationnotipay",
            id: "-1",
            jsonData: {},
            jsonerrorResponse: "",
            jsonerrorRequest: "",
        };
    },
    watch: {},
    mounted() {},
    methods: {
        init(id) {
            this.id = id;
            this.loadData();
        },
        loadData() {
            this.notificationNotipayResponseDettaglioLoadData(this.id, this.afterLoadData);
        },
        afterLoadData() {
            this.jsonData = this.notificationNotipayDettaglioResponse;
            /*  this.jsonData.bodyRequest = JSON.parse(this.notificationNotipayDettaglioResponse.bodyRequest);
            this.jsonData.bodyResponse = JSON.parse(this.notificationNotipayDettaglioResponse.bodyResponse); */
        },
        prettyFormat(data) {
            let me = this;
            me.jsonerror = "";
            let jsonValue = "";
            try {
                jsonValue = JSON.parse(data);
            } catch (e) {
                console.log(e.message);
                me.jsonerror = JSON.stringify(e.message);
                var textarea = document.getElementById("jsonText");
                if (me.jsonerror.indexOf("position") > -1) {
                    // highlight error position
                    var positionStr = me.jsonerror.lastIndexOf("position") + 8;
                    var posi = parseInt(me.jsonerror.substr(positionStr, me.jsonerror.lastIndexOf('"')));
                    if (posi >= 0) {
                        textarea.setSelectionRange(posi, posi + 1);
                    }
                }
                console.log(me.jsonerror);
                return "";
            }
            return JSON.stringify(jsonValue, null, 4);
        },
    },
};
</script>
